import React from 'react';
import PlaylistControllerHelperView from 'src/lib/playlist/PlaylistControllerHelperView';
import useFilePicker from '../10-atoms/file-picker/hooks/useFilePicker';
import useHTMLEditor from '../10-atoms/form/inputs/editor/html/HTMLEditor/useHTMLEditor';
import useTopicPicker from '../10-atoms/form/inputs/topics-input/TopicPickerOverlay/useTopicPicker';
import BottomDrawerHelperView from './bottom-drawer/BottomDrawerHelperView';
import DatePickerHelperView from './date-picker/DatePickerHelperView';
import HiddenViewHelperView from './hidden-view/HiddenViewHelperView';
import ImageViewerHelperView from './image-viewer/ImageViewHelperView';
import OverlayHelperView from './overlay';
import PDFViewHelperView from './pdf-viewer/PDFViewHelperView';
import SnackbarHelperView from './snackbar/SnackbarHelperView';
const HelperViews = ({}) => {
    useTopicPicker();
    useHTMLEditor();
    useFilePicker();
    return (React.createElement(React.Fragment, null,
        React.createElement(HiddenViewHelperView, null),
        React.createElement(PlaylistControllerHelperView, null),
        React.createElement(OverlayHelperView, null),
        React.createElement(BottomDrawerHelperView, null),
        React.createElement(SnackbarHelperView, null),
        React.createElement(ImageViewerHelperView, null),
        React.createElement(DatePickerHelperView, null),
        React.createElement(PDFViewHelperView, null)));
};
export default HelperViews;
